import React from 'react';
import PropTypes from 'prop-types';
import { FormControlLabel, Checkbox, TableCell, TableRow } from '@mui/material';
import moment from 'moment';
import { BoxWrapper, OfferNumberWrapper } from '../BulkPrintingListStyles';
import { AssignmentInd, CalendarToday, Description, Info, LabelImportant } from '@mui/icons-material';

const BulkPrintingListItem = ({ item, onSelectOffer, selectedOfferList }) => {
  return (
    <TableRow>
      <TableCell>
        <FormControlLabel
          control={
            <Checkbox
              id={'bulkPrinting_isSelected'}
              checked={
                selectedOfferList.find(offer => offer.offerId === item.offerId && offer.offerSiteId === item.offerSiteId)
                  ? true
                  : false || false
              }
              onChange={onSelectOffer(item)}
              color='primary'
              name='isSelected'
              size='small'
            />
          }
        />
      </TableCell>
      <TableCell>
        <BoxWrapper>
          <LabelImportant />
          <OfferNumberWrapper>{item.offerNumber || ''}</OfferNumberWrapper>
        </BoxWrapper>
      </TableCell>
      <TableCell>
        <BoxWrapper>
          {item?.clientName && <AssignmentInd />}
          {item?.clientName || ''}{' '}
        </BoxWrapper>
      </TableCell>
      <TableCell>
        <BoxWrapper>
          {item.contractNumbers && <Description />}
          {item.contractNumbers || ''}
        </BoxWrapper>
      </TableCell>
      <TableCell>
        <BoxWrapper>
          <CalendarToday />
          {moment(item.offerDate).format('DD/MM/YYYY') || ''}
        </BoxWrapper>
      </TableCell>
      <TableCell>
        <BoxWrapper>
          <Info />
          <span>{item.offerStateName || ''}</span>
        </BoxWrapper>
      </TableCell>
    </TableRow>
  );
};

BulkPrintingListItem.propTypes = {
  item: PropTypes.object.isRequired,
  onSelectOffer: PropTypes.func.isRequired,
  selectedOfferList: PropTypes.array.isRequired
};

export default BulkPrintingListItem;
